import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector } from '@angular/core';
import { ModalAlertRegresiveComponent } from '@pacifico/components/modal-alert-regresive/modal-alert-regresive.component';
import { ModalAlertComponent } from '@pacifico/components/modal-alert/modal-alert.component';
import { DialogRef } from '@pacifico/components/modal-side/models/modal-ref';
import { TypeAlert } from '@pacifico/types/types-model-components';
import { ModalFunction } from '@pacifico/utils/modal-fuction';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertService {
	$subject = new Subject<{ title: string; message: string; type: TypeAlert }>();

	showInfo(message: string, title?: string): void {
		const sendTitle = title ? title : 'Información';
		this.$subject.next({ title: sendTitle, message: message, type: 'info' });
	}

	showError(message: string, title?: string): void {
		const sendTitle = title ? title : 'Error';
		this.$subject.next({ title: sendTitle, message: message, type: 'error' });
	}

	showSuccess(message: string, title?: string): void {
		const sendTitle = title ? title : '¡Listo!';
		this.$subject.next({ title: sendTitle, message: message, type: 'succes' });
	}

	showWarning(message: string, title?: string): void {
		const sendTitle = title ? title : 'Advertencia';
		this.$subject.next({ title: sendTitle, message: message, type: 'warn' });
	}
}

@Injectable({ providedIn: 'root' })
export class ModalAlertService {
	dialogComponentRef!: ComponentRef<ModalAlertComponent>;
	private _modalFunction!: ModalFunction<ModalAlertComponent>;

	constructor(componentFactoryResolver: ComponentFactoryResolver, appRef: ApplicationRef, injector: Injector) {
		this._modalFunction = new ModalFunction(componentFactoryResolver, appRef, injector, ModalAlertComponent, false);
	}

	showInfo(message: string, title?: string, autoClose?: boolean): void {
		const sendTitle = title ? title : 'Información';
		this._showModal(message, 'info', sendTitle, false, autoClose);
	}

	showError(message: string, title?: string, autoClose?: boolean): void {
		const sendTitle = title ? title : 'Error';
		this._showModal(message, 'error', sendTitle, false, autoClose);
	}

	showSucces(message: string, title?: string, autoClose?: boolean): void {
		const sendTitle = title ? title : '¡Listo!';
		this._showModal(message, 'succes', sendTitle, false, autoClose);
	}

	showWarning(
		message: string,
		title?: string,
		showbuttonCancel?: boolean,
		autoClose?: boolean,
		showButtonClose?: boolean,
		textFirstButton?: string,
		textSecondButton?: string
	): DialogRef {
		const sendTitle = title ? title : 'Advertencia';
		return this._showModal(
			message,
			'warn',
			sendTitle,
			showbuttonCancel,
			autoClose,
			showButtonClose,
			textFirstButton,
			textSecondButton
		);
	}

	private _showModal(
		message: string,
		type: TypeAlert,
		title: string,
		showbuttonCancel?: boolean,
		autoClose?: boolean,
		showButtonClose?: boolean,
		textFirstButton?: string,
		textSecondButton?: string
	): DialogRef {
		const ref = this._modalFunction.appendDialogComponentToBody();
		this.dialogComponentRef = this._modalFunction.dialogComponentRef;
		this.dialogComponentRef.instance.title = title;
		this.dialogComponentRef.instance.message = message;
		this.dialogComponentRef.instance.type = type;
		if (showButtonClose !== null || showButtonClose !== undefined) {
			this.dialogComponentRef.instance.showButtonClose = showButtonClose ? showButtonClose : false;
		}
		if (textFirstButton) {
			this.dialogComponentRef.instance.textFirstButton = textFirstButton;
		}
		if (textSecondButton) {
			this.dialogComponentRef.instance.textSecondButton = textSecondButton;
		}

		if (autoClose !== undefined && autoClose !== null) {
			this.dialogComponentRef.instance.autoClose = autoClose;
		}

		this.dialogComponentRef.instance.showButtonCancel = showbuttonCancel ?? true;
		return ref;
	}
}

@Injectable({ providedIn: 'root' })
export class ModalAlertRegresiveService {
	dialogComponentRef!: ComponentRef<ModalAlertRegresiveComponent>;
	private _modalFunction!: ModalFunction<ModalAlertRegresiveComponent>;

	constructor(componentFactoryResolver: ComponentFactoryResolver, appRef: ApplicationRef, injector: Injector) {
		this._modalFunction = new ModalFunction(
			componentFactoryResolver,
			appRef,
			injector,
			ModalAlertRegresiveComponent,
			false
		);
	}

	showUndoTransfer(
		message: string,
		title?: string,
		showbuttonCancel?: boolean,
		showButtonClose?: boolean,
		textFirstButton?: string,
		textSecondButton?: string
	): DialogRef {
		const sendTitle = title ? title : 'Enviando';
		return this._showModal(
			message,
			'warn',
			sendTitle,
			showbuttonCancel,
			showButtonClose,
			textFirstButton,
			textSecondButton
		);
	}

	private _showModal(
		message: string,
		type: TypeAlert,
		title: string,
		showbuttonCancel?: boolean,
		showButtonClose?: boolean,
		textFirstButton?: string,
		textSecondButton?: string
	): DialogRef {
		const ref = this._modalFunction.appendDialogComponentToBody();
		this.dialogComponentRef = this._modalFunction.dialogComponentRef;
		this.dialogComponentRef.instance.title = title;
		this.dialogComponentRef.instance.message = message;
		this.dialogComponentRef.instance.type = type;
		if (showButtonClose !== null || showButtonClose !== undefined) {
			this.dialogComponentRef.instance.showButtonClose = showButtonClose ? showButtonClose : false;
		}
		if (textFirstButton) {
			this.dialogComponentRef.instance.textFirstButton = textFirstButton;
		}
		if (textSecondButton) {
			this.dialogComponentRef.instance.textSecondButton = textSecondButton;
		}
		this.dialogComponentRef.instance.showButtonCancel = showbuttonCancel ?? true;
		return ref;
	}
}
